const catalog = {
	financePeriodicity: { 1: 'Annuelle', 2: 'Trimestrielle', 3: 'Mensuelle' },
	currency: {
		EUR: 'Euro',
		USD: 'Dollar',
		CHF: 'Franc Suisse',
		XOF: 'Franc CFA',
		TND: 'Dinar',
		GBP: 'Livre',
		INR: 'Roupie',
		KES: 'Shilling',
		SAR: 'Rial',
		MXN: 'Peso',
		SEK: 'Couronne',
	},
	langOption: {
		fr: 'Français (défaut)',
		en: 'Anglais (défaut)',
		es: 'Espagnol',
		de: 'Allemand',
		it: 'Italien',
		nl: 'Néerlandais',
		fi: 'Finnois',
		eu: 'Basque',
		ca: 'Catalan',
		backoffFr: 'Français (défaut)',
		backoffEn: 'Anglais (défaut)',
		backoffEs: 'Espagnol',
		backoffDe: 'Allemand',
		backoffIt: 'Italien',
		backoffNl: 'Néerlandais',
	},
	frontLang: {
		Français: 'Français (défaut)',
		Anglais: 'Anglais (défaut)',
		Espagnol: 'Espagnol',
		Allemand: 'Allemand',
		Italien: 'Italien',
		Néerlandais: 'Néerlandais',
		Finnois: 'Finnois',
		Basque: 'Basque',
		Catalan: 'Catalan',
	},
	identifiant: {
		aucun: 'Aucun',
		qrcode: 'Numéro Otipass sous forme de QR Code',
		clair: 'Numéro Otipass en clair (8 chiffres)',
		unique: 'Identifiant unique Otipass (séquentiel)',
		serie: 'Numéro de série (transport)',
		calypso: 'Numéro Calypso (transport)',
		amc: 'Numéro AMC',
		autre: 'Autre',
	},
	frequence: {
		synchroInit: 'Synchro initiale (une seule fois au démarrage du projet)',
		synchroMens: 'Synchro périodique quotidienne',
		other: 'Autre',
	},
	placeholders: {
		tel: 'Exemple : +33 123456789',
		email: 'Exemple : prenom.nom@domaine.com',
	},
	countries: {
		France: 'France',
		Belgique: 'Belgique',
		Luxembourg: 'Luxembourg',
		Suisse: 'Suisse',
		Allemagne: 'Allemagne',
		Espagne: 'Espagne',
		Italie: 'Italie',
		Portugal: 'Portugal',
		'Pays-Bas': 'Pays-Bas',
		Irlande: 'Irlande',
		Autriche: 'Autriche',
		Danemark: 'Danemark',
		Suède: 'Suède',
		Finlande: 'Finlande',
		Grèce: 'Grèce',
		Pologne: 'Pologne',
		Hongrie: 'Hongrie',
		Tchéquie: 'Tchéquie',
		Slovaquie: 'Slovaquie',
		Slovénie: 'Slovénie',
		Roumanie: 'Roumanie',
		Bulgarie: 'Bulgarie',
		Estonie: 'Estonie',
		Lettonie: 'Lettonie',
		Lituanie: 'Lituanie',
		Croatie: 'Croatie',
		Malte: 'Malte',
		Chypre: 'Chypre',
		'République tchèque': 'République tchèque',
	},
	pj: {
		id: "Pièce d'identité",
		home: 'Justificatif de domicile',
		tax: "Avis d'imposition",
		other: 'Autre',
	},
	payment: {
		SystemPay: 'SystemPay',
		Atos: 'Atos',
		Payrexx: 'Payrexx',
		Twint: 'Twint (via Payrexx)',
		PayPal: 'PayPal',
		Monetico: 'Monetico',
		OrangeMoney: 'OrangeMoney',
		PayFip: 'PayFip',
		Paytrail: 'Paytrail',
		PayBox: 'PayBox',
		Avizi: 'Avizi',
		Wave: 'Wave',
		Autre: 'Autre',
	},
	featuresForm: {
		compte: 'Compte famille',
		pj: 'Gestion des Pièces justificatives',
		captcha: 'Captcha / anti-bot',
		rgpd: 'Consentement RGPD',
	},
	featuresBoutique: {
		passCourt: 'Achat Pass courte durée',
		passLong: 'Achat Pass longue durée',
		renew: 'Renouvellement Pass longue durée',
		tarif: 'Tarif préférentiel renouvellement',
		multi: 'Commande de plusieurs Pass',
		cadeau: 'Achat carte cadeau',
		promo: "Ajout/Suppression d'un code promo",
		quick: 'Achat rapide sans création de compte',
		activation: "Saisie de la date d'arrivée pour activation automatique de Pass à cette date",
		cb: 'Paiement en CB/PayPal',
		otipoints: 'Paiement en points (otipoints)',
		cheque: 'Paiement par chèque',
		chequeVac: 'Paiement en chèque-vacances',
		facility: 'Paiement en plusieurs fois',
		recurrent: 'Paiement récurrent (abonnements)',
		loyalty: 'Programme de fidélité (otipoints)',
		eticket: 'Envoi immédiat e-ticket',
		post: 'Envoi postal supports physiques',
		pickup: 'Retrait en point de vente',
		invoice: 'Facturation',
		multiDev: 'Multidevise',
		multiLang: 'Multilangue',
		deferred: 'Paiement différé',
		transfer: 'Paiement par virement',
		sso: 'SSO (FranceConnect)',
	},
	champsFormula: {
		package: { label: 'Package', title: 'Libellé de la formule', ph: 'Ex. Pass annuel' },
		reference: { label: 'Réf.', title: 'Référence', ph: 'P1' },
		duree: { label: 'Durée', title: "Nombre de jours d'utilisation du Pass", ph: '365' },
		periode: { label: 'Période', title: 'Période glissante', ph: '365' },
		tarifAdulte: { label: 'Adulte', title: 'Tarif Adulte (€)' },
		tarifEnfant: { label: 'Enfant', title: 'Tarif Enfant (€)' },
		accompagnants: { label: 'Acc.', title: 'Nombre de personnes accompagnantes' },
	},
	userData: {
		'Civilité': 'Civilité',
		'Nom': 'Nom',
		'Prénom': 'Prénom',
		'Date de naissance': 'Date de naissance',
		'Adresse email': 'Adresse email',
		'N° rue': 'N° rue',
		'Rue': 'Rue',
		"Complément d'adresse": "Complément d'adresse",
		'Code postal': 'Code postal',
		'Ville': 'Ville',
		'Pays': 'Pays',
		'Tél. 1': 'Tél. 1',
		'Tél. 2': 'Tél. 2',
	},
};

export default catalog;
